import { observer } from "mobx-react-lite";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useAuthStore } from "../hooks";
import { useTran } from "@/hooks";

export const SessionExpiredDialog = observer(() => {
  const { t } = useTran();
  const authStore = useAuthStore();

  return (
    <Dialog open={authStore.showSessionExpired} onOpenChange={() => {}}>
      <DialogContent
        className="sm:max-w-md"
        onEscapeKeyDown={(event) => event.preventDefault()}
        onPointerDownOutside={(event) => event.preventDefault()}
      >
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-rose-100 dark:bg-rose-900/20">
              <AlertTriangle className="h-5 w-5 text-rose-600 dark:text-rose-500" />
            </div>
            <DialogTitle>{t("Session expired")}</DialogTitle>
          </div>
        </DialogHeader>

        <DialogDescription className="py-4">
          {authStore.sessionExpiredMessage ||
            t("Please login again to continue.")}
        </DialogDescription>

        <DialogFooter>
          <Button type="button" onClick={authStore.confirmSessionExpired}>
            {t("Go to login")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
});

SessionExpiredDialog.displayName = "SessionExpiredDialog";
